import { Flex, Skeleton } from "antd";

const LoadingState = () => (
  <Flex vertical justify="center" align="center" className="mt-5" gap={12}>
    <Skeleton.Input active style={{ width: "400px" }} />
    <Skeleton.Input active style={{ width: "400px" }} />
    <Skeleton.Input active style={{ width: "400px" }} />
  </Flex>
);

export default LoadingState;
